import { defineStore } from 'pinia'
import { client } from '@/services/client'
import { useSpace } from '@/store/modules/App/space'
import { type Activity, type ActivityFilterParams } from '@/types'

export type State = {
  activities: Activity[]
  totalActivities: number
}

const state = (): State => ({
  activities: [],
  totalActivities: 0,
})

const getters = {
  getActivities: (state: State): Activity[] => state.activities,
  getTotalActivities: (state: State): number => state.totalActivities,
}

const actions = {
  setActivities(activities: Activity[]): Activity[] {
    return (this.activities = activities)
  },

  setTotalActivities(total: number): number {
    return (this.totalActivities = total)
  },

  async loadActivities({
    params,
    region = undefined,
  }: {
    params: ActivityFilterParams
    region?: string | undefined
  }): Promise<unknown> {
    const { space_id: spaceId } = params
    try {
      const response = await client.get(`/spaces/${spaceId}/activities`, {
        params: { ...params },
        region: region || useSpace().region,
      })

      this.setActivities(response.data.activities)
      this.setTotalActivities(parseInt(response.headers.total, 10))

      return response.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
}

export const useActivities = defineStore('activities', {
  state,
  getters,
  actions,
})
